module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_England-Humanities.9f066802.jpg";